module.exports = __webpack_public_path__ + "img/testimonials-img-1.bf9b97d2.png";